exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-09d2ff5c] {\n\n    margin: 0px;\n}\n.custom-payment-wrapper[data-v-09d2ff5c] {\n    font-family: 'Inter', sans-serif !important;\n    background-color: #094824;\n    padding-top: 50px;\n}\n.container[data-v-09d2ff5c] {\n    background-color: #f9fbff;\n    height: 80vh;\n    overflow: hidden;\n}\nbutton[data-v-09d2ff5c] {\nbackground: linear-gradient(to bottom right, #198754, #14783f);\n-webkit-text-fill-color: #ffffff;\nborder: #094824;\n}\nbutton[data-v-09d2ff5c]:hover {\nbackground: linear-gradient(to bottom right, #14783f, #198754);\n}\n.soimg[data-v-09d2ff5c]{\n    width:100px ;\n}\n", ""]);

// exports
